<template>
  <div class="customerForgetRemind">
    <div class="title">
      <i class="el-icon-message-solid" style="color: #006eff"></i>
      客户遗忘提醒
    </div>
    <ul>
      <li v-for="(item,index) in 6" :key="index">
        <div class="itemName">{{ titleList[index] }}</div>
        <div class="num">
          <b>{{ numList[index] }}</b>
          <span>人</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleList: ['超过7天未联系', '超过15天未联系', '超过30天未联系', '超过3个月未联系', '超过6个月未联系', '逾期未联系'],
      numList: [0, 0, 0, 0, 0, 0]
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios.get(`/Crm/Static/CustomerForgetRemind`).then(res => {
        this.numList = [
          res.sevenDays,
          res.fifteenDays,
          res.thirtyDays,
          res.threeMonths,
          res.sixMonths,
          0
        ]
      })
    }
  }
}
</script>

<style scoped lang="scss">
.customerForgetRemind {
  flex: 1;
  box-sizing: border-box;
  border: 1px solid #dfe0eb;
  border-radius: 12px;
  border-top: 3px solid #006eff;
  padding: 5px 0 39px 15px;
  background: white;
  box-shadow: 0 2px 6px 0 rgba(218, 218, 253, 65%), 0 2px 6px 0 rgba(206, 206, 238, 54%);

  .title {
    font-weight: bold;
    font-size: 18px;
    margin-top: 10px;
  }

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      flex: 1;
      margin-right: 15px;
      border: 1px solid #dfe0eb;
      border-radius: 50%;
      text-align: center;
      min-width: 180px;
      padding: 6px 15px;
      margin-top: 38px;
      box-shadow: 0 5px 0 0 #006eff, 0 10px 5px 0 rgba(0, 0, 0, .5);

      //transition: all .1s;
      //cursor: pointer;
      //box-shadow: 0 5px 0 0 #006eff,
      //0 10px 5px 0 rgba(0, 0, 0, .5);
      transform: translateY(-8px);

      .itemName {
        font-weight: bold;
      }

      .num {
        b {
          font-size: 22px;
        }
      }

      //&:active {
      //  transform: translateY(0);
      //  box-shadow: 0 0
      //}

    }
  }
}
</style>
